import React, { useState, useEffect } from 'react';
import VideoCard from '../../../components/VideoCard';
import Icon from '../../../components/AppIcon';


const NewContentCarousel = ({ newContent, onWhatsAppRequest }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const handlePrevious = () => {
    setCurrentIndex((prev) => (prev - 1 + newContent?.length) % newContent?.length);
  };

  const handleNext = () => {
    setCurrentIndex((prev) => (prev + 1) % newContent?.length);
  };

  const handleDotClick = (index) => {
    setCurrentIndex(index);
  };

  if (newContent?.length === 0) {
    return null;
  }

  const visibleContent = newContent?.slice(currentIndex, currentIndex + 3);
  if (visibleContent?.length < 3 && newContent?.length >= 3) {
    visibleContent?.push(...newContent?.slice(0, 3 - visibleContent?.length));
  }

  return (
    <div className="w-full bg-gradient-to-br from-card via-background to-card rounded-xl p-6 md:p-8 lg:p-10 shadow-glow-lg border border-border/50 hover:border-primary/30 transition-all duration-500">
      <div className="flex items-center justify-between mb-6 md:mb-8">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 md:w-12 md:h-12 bg-primary/20 rounded-full flex items-center justify-center shadow-glow-md hover:shadow-glow-lg transition-all duration-300 hover:scale-110">
            <Icon name="Sparkles" size={24} color="var(--color-primary)" className="animate-pulse-neon" />
          </div>
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground">
              Novidades
            </h2>
            <p className="text-sm md:text-base text-muted-foreground">
              Conteúdos recém-adicionados
            </p>
          </div>
        </div>

        <div className="flex items-center gap-2">
          <button
            onClick={handlePrevious}
            className="w-10 h-10 bg-card border border-border rounded-full flex items-center justify-center transition-all duration-300 hover:shadow-glow-md hover:scale-110 hover:border-primary/50 focus-ring"
            aria-label="Anterior"
          >
            <Icon name="ChevronLeft" size={20} color="var(--color-primary)" />
          </button>
          <button
            onClick={handleNext}
            className="w-10 h-10 bg-card border border-border rounded-full flex items-center justify-center transition-all duration-300 hover:shadow-glow-md hover:scale-110 hover:border-primary/50 focus-ring"
            aria-label="Próximo"
          >
            <Icon name="ChevronRight" size={20} color="var(--color-primary)" />
          </button>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
        {visibleContent?.map((content) => (
          <div key={content?.id} className="relative">
            <div className="absolute top-3 left-3 z-10 px-3 py-1.5 bg-accent/90 text-white text-xs font-bold rounded-lg shadow-glow-accent animate-pulse-neon">
              NOVO
            </div>
            <VideoCard
              content={content}
              onWhatsAppRequest={onWhatsAppRequest}
              onContentClick={() => {}}
              onRatingChange={() => {}}
              variant="default"
            />
          </div>
        ))}
      </div>

      <div className="flex items-center justify-center gap-2 mt-6">
        {newContent?.map((_, index) => (
          <button
            key={index}
            onClick={() => handleDotClick(index)}
            className={`h-2 md:h-3 rounded-full transition-all duration-300 hover:scale-125 ${
              index === currentIndex
                ? 'bg-primary w-6 md:w-8 shadow-glow-md' : 'bg-muted-foreground hover:bg-primary w-2 md:w-3'
            }`}
            aria-label={`Ir para slide ${index + 1}`}
          />
        ))}
      </div>
    </div>
  );
};

export default NewContentCarousel;